import { render } from "./loginbanner.vue?vue&type=template&id=62646f3d"
import script from "./loginbanner.vue?vue&type=script&lang=js"
export * from "./loginbanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__